import { get } from 'lodash';
import DatadogHandler from 'utils/datadog';
import {
  msAddUpdateSpouse,
  msRemoveChildSpouse,
  msSaveParentParticulars,
} from 'services/UserService';
import {
  msUpdateChildParticular,
  msFetchChildProfileByID,
  monoFetchChildProfileByID,
} from 'services/ChildService';
import { FEATURE_FLAGS } from 'utils/constants';
import { SkApolloRequest } from '../../utils/apolloUtils';
import { actionHandlerWithFeatureFlag, parseGraphQLError } from '../../utils';
import {
  ADD_UPDATE_SPOUSE,
  REMOVE_CHILD_SPOUSE,
  UPDATE_CHILD_PARTICULAR,
} from '../models/childDetailsModel';

const fileName = 'src/redux/actions/ChildDetails.js';

export const monoSaveParentParticulars = async (_, data) => {
  try {
    const reqData = [];

    if (Object.keys(data).length === 0) {
      return {
        success: true,
      };
    }

    if (get(data, 'nationalityData', false)) {
      reqData.push({
        key: 'updateParentNationality',
        query: '{ ID }',
        variables: [data.nationalityData],
      });
    }

    if (get(data, 'maritialData', false)) {
      reqData.push({
        key: 'updateParentMaritalStatus',
        query: '{ ID }',
        variables: [data.maritialData],
      });
    }

    if (get(data, 'workingStatusData', false)) {
      reqData.push({
        key: 'updateParentWorkingStatus',
        query: '{ ID }',
        variables: [data.workingStatusData],
      });
    }
    if (get(data, 'updateEmailMobile', false)) {
      reqData.push({
        key: 'updateParentEmailOrMobile',
        query: '{ ID }',
        variables: [data.updateEmailMobile],
      });
    }

    if (get(data, 'parentNameData', false)) {
      reqData.push({
        key: 'updateParentName',
        query: '{ ID }',
        variables: [data.parentNameData],
      });
    }

    if (get(data, 'parentIdentificationNoData', false)) {
      reqData.push({
        key: 'updateParentIdentificationNo',
        query: '{ ID }',
        variables: [data.parentIdentificationNoData],
      });
    }

    if (get(data, 'parentAddressData', false)) {
      reqData.push({
        key: 'addOrUpdateParentAddress',
        query: '{ ID }',
        variables: [data.parentAddressData],
      });
    }

    if (get(data, 'parentDobData', false)) {
      reqData.push({
        key: 'updateParentBirthdate',
        query: '{ ID }',
        variables: [data.parentDobData],
      });
    }

    if (get(data, 'parentRelationData', false)) {
      reqData.push({
        key: 'updateParentRelation',
        query: '{ ID }',
        variables: [data.parentRelationData],
      });
    }

    return await SkApolloRequest({
      params: reqData,
      type: 'bulkMutation',
    });
  } catch (ex) {
    return {
      success: false,
      inProgress: false,
      error: [parseGraphQLError(ex)],
    };
  }
};

export const saveParentParticulars = data => async dispatch => {
  const result = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msSaveParentParticulars,
      monoHandler: monoSaveParentParticulars,
      extraData: data,
    }
  );
  return result;
};

export const monoUpdateChildParticular = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: UPDATE_CHILD_PARTICULAR,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoUpdateChildParticular',
      },
      'error'
    );
    return {
      error: ex.message,
      success: false,
    };
  }
};

export const updateChildParticularV2 = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msUpdateChildParticular,
      monoHandler: monoUpdateChildParticular,
      extraData: reqData,
    }
  );
};

export const monoAddUpdateSpouse = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: ADD_UPDATE_SPOUSE,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoAddUpdateSpouse',
      },
      'error'
    );
    return {
      error: ex.message,
      success: false,
    };
  }
};

export const addUpdateSpouse = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msAddUpdateSpouse,
      monoHandler: monoAddUpdateSpouse,
      extraData: reqData,
    }
  );
};

export const monoRemoveChildSpouse = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: REMOVE_CHILD_SPOUSE,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoRemoveChildSpouse',
      },
      'error'
    );
    return {
      error: ex.message,
      success: false,
    };
  }
};

export const removeChildSpouse = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msRemoveChildSpouse,
      monoHandler: monoRemoveChildSpouse,
      extraData: reqData,
    }
  );
};

export const fetchChildProfileByID = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msFetchChildProfileByID,
      monoHandler: monoFetchChildProfileByID,
      extraData: reqData,
    }
  );
};

export default saveParentParticulars;
